type TConvertFunction = (key: string) => string;

export function convertObjectKeys<TObject extends Record<string, unknown>>(
  object: TObject,
  convertFunction: TConvertFunction,
): TObject {
  return Object.fromEntries(
    Object
      .entries(object)
      .map((entry: [string, unknown]) => [
        convertFunction(entry[0]),
        entry[1],
      ]),
  ) as TObject;
}
